import { sumBy } from 'lodash'
import {
  IFacilityScheduleHour,
  IFacilityScheduleRulesUnloadTypes,
  IShipmentStopTypes,
} from 'types/graphqlTypes'
import { getFacilityHoursForStopAndUnloadType } from './getFacilityHoursForStopAndUnloadType'

const START_TIME_24_7 = '00:00'
const END_TIME_24_7 = '23:59'

export const isFacilityOpen247 = (
  hours: IFacilityScheduleHour[],
  stopType: IShipmentStopTypes,
  unloadType: IFacilityScheduleRulesUnloadTypes
) => {
  const relevantHours = getFacilityHoursForStopAndUnloadType(hours, stopType, unloadType)
  const numOf247Days = sumBy(relevantHours, ({ endTime, startTime }) =>
    Number(startTime === START_TIME_24_7 && endTime === END_TIME_24_7)
  )

  return numOf247Days === 7
}
